//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Query from "./components/Query.vue";
import Result from "./components/Result.vue";
export default {
  name: "FSCSearch",
  components: {
    Query,
    Result,
  },
};
